import { Fragment } from 'react'
import { toast } from 'react-toastify'
import { X } from 'lucide-react'

import Avatar from '@components/avatar'
import { isCancelled } from './utils'

const ErrorToast = ({ message }) => (
  <Fragment>
    <div className='toastify-header'>
      <div className='title-wrapper'>
        <Avatar size='sm' color='danger' icon={<X size={12} />} />
        <h6 className='toast-title'>Error!</h6>
      </div>
    </div>
    <div className='toastify-body'>
      <span role='img' aria-label='toast-text'>{message}</span>
    </div>
  </Fragment>
)

const notify = (message) => toast.error(<ErrorToast message={message} />)

// === Status-specific handlers ===

const formatValidationMessage = (errors, fallback) => {
  if (!errors) return fallback
  return Object.values(errors)
    .map((messages) => messages[0])
    .filter(Boolean)
    .join(' ')
    .trim() || fallback
}

const handle422 = ({ data }) => {
  notify(formatValidationMessage(data?.errors, data?.message))
}

const handle500 = ({ data }) => {
  const message = data?.message || ''
  if (message.includes('file_put_contents')) {
    window.location.reload()
    return
  }
  notify('An unexpected error occurred. Contact the administrator.')
}

const handle404 = () => notify('Resource not found')

const STATUS_HANDLERS = {
  404: handle404,
  422: handle422,
  500: handle500
}

// === Entry point ===

export const handleAxiosError = (error) => {
  if (isCancelled(error)) return
  if (!error.response) {
    notify('Network error. Please check your connection.')
    return
  }
  const handler = STATUS_HANDLERS[error.response.status]
  if (handler) handler(error.response)
}
